import React from 'react'
// @ts-ignore
import { MediaItem } from '@netbasequid/core'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import { RichMentionedUrl } from 'schemas/RichMentionedUrlSchema'
import styled from 'styled-components'
// @ts-ignore
import { basicColor, sys } from '@netbasequid/theme'
import { useTranslation } from 'react-i18next'
import { PostMetric } from 'schemas/PostMetricSchema'
import { filterVideoOrImageMedia } from './utils'
import { VideoOrImageRichMentionedUrl } from '../../types'

export type MediaClickHandler = (
  mentionedUrls: VideoOrImageRichMentionedUrl[],
  index: number
) => void

const StyledPreviewNAWording = styled.div<{ mode: Theme }>`
  font-weight: ${sys.fontWeight.regular};
  font-size: ${sys.typescale[12].size};
  line-height: ${sys.typescale[12].lineHeight};
`

const StyledMediaItemContainer = styled.div<{ mode: Theme }>`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  padding: 8px 12px;
  border-top: 1px solid ${({ mode }: { mode: Theme }) => sys[mode].common.divider[100]};
`

export interface MediaGridProps {
  postMetric: PostMetric
  onMediaClick?: MediaClickHandler
}

const MEDIA_ITEM_WIDTH = '200px'
const MEDIA_ITEM_HEIGHT = '200px'

const MediaGrid = ({ postMetric, onMediaClick }: MediaGridProps): React.ReactElement => {
  const theme = useDisplayTheme() as Theme
  const { t } = useTranslation()

  const { mentionedUrls } = postMetric
  const videoOrImageMediaUrls = filterVideoOrImageMedia(mentionedUrls!)

  if (videoOrImageMediaUrls?.length === 0) {
    return <></>
  }

  return (
    <StyledMediaItemContainer mode={theme}>
      {videoOrImageMediaUrls?.map((urlItem: RichMentionedUrl, index: number) => (
        <MediaItem
          // eslint-disable-next-line react/no-array-index-key
          key={`${urlItem?.mediaType}-${index}-${urlItem?.mediaUrl}`}
          mode={theme}
          data={{
            mediaType: urlItem?.mediaType,
            mediaUrl: urlItem?.mediaUrl,
            thumbnailUrl: urlItem?.thumbnailUrl
          }}
          width={MEDIA_ITEM_WIDTH}
          height={MEDIA_ITEM_HEIGHT}
          previewNaUrl="https://help.quid.com/articles/8240236#h_24b221c46b"
          previewNaUrlWording={
            <StyledPreviewNAWording mode={theme}>{t('moreThreeDot')}</StyledPreviewNAWording>
          }
          previewNaWording={
            <StyledPreviewNAWording mode={theme}>{t('previewUnavailable')}</StyledPreviewNAWording>
          }
          backgroundColor={theme === 'dark' ? basicColor.GRAY_1200 : basicColor.GRAY_300}
          onClick={() => onMediaClick && onMediaClick(videoOrImageMediaUrls, index)}
        />
      ))}
    </StyledMediaItemContainer>
  )
}

export default MediaGrid
